import React from 'react';
import { AllieText, AllieSelect, DarkTooltip } from '../../../../components';
import { Filter } from '../FilterBar';

interface SelectFilterProps {
  filter: Omit<Filter, 'type'>;
  labelAll: string;
  className?: string;
  displayText: string;
  options: { text: string; value: string }[] | undefined;
  namespace: string;
}

export const SelectFilter: React.FC<SelectFilterProps> = ({
  filter,
  labelAll,
  className,
  displayText,
  options,
  namespace,
}) => {
  const {
    label,
    handleChange,
    selected,
    disabled,
    cssClass,
    interfaceOptions,
    filterLabelAll,
    showTooltip,
    tooltipText,
    tooltipSide = 'bottom',
    tooltipAlignment = 'end',
    multiple,
    'data-testid': dataTestId,
  } = filter;

  return (
    <div className={`${namespace}__item`} data-testid={dataTestId}>
      <AllieText
        className={`${namespace}__label`}
        type="body3"
        weight={400}
        color="neutral-50"
      >
        {label}
      </AllieText>
      <DarkTooltip 
        text={tooltipText || ''} 
        side={tooltipSide}
        alignment={tooltipAlignment}
        disabled={!showTooltip || !tooltipText}
      >
        <AllieSelect
          className={`${namespace}__item__select`}
          options={options || []}
          color={{
            backgroundColor: 'white',
            allieColor: 'neutral-90',
          }}
          selectedText={displayText}
          selected={selected}
          placeholder={filterLabelAll || labelAll}
          onChange={handleChange}
          disabled={disabled}
          interfaceOptions={{
            cssClass: `${className ?? ''} ${cssClass ?? ''}`,
            arrow: false,
            size: 'cover',
            ...interfaceOptions,
          }}
          multiple={multiple}
        />
      </DarkTooltip>
    </div>
  );
}; 